import { Injectable } from '@angular/core';
import { Router, ActivatedRoute, NavigationEnd, Params, PRIMARY_OUTLET } from '@angular/router';
import { Subject } from 'rxjs';
import { filter } from 'rxjs/operators';

import { IBreadcrumb } from '../models/breadcrumb-models';

@Injectable({
  providedIn: 'root'
})
export class BreadcrumbDataService {

  public breadcrumbs: IBreadcrumb[];

  public last: IBreadcrumb;
  public onChanges = new Subject<IBreadcrumb[]>();

  constructor(
    private activatedRoute: ActivatedRoute,
    private router: Router
  ) {
    this.breadcrumbs = [];

    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd)
    ).subscribe((event: NavigationEnd) => {
      this.breadcrumbs = this.getBreadcrumbs(this.activatedRoute.root);
      this.onChanges.next(this.breadcrumbs);
    });
  }

  private getBreadcrumbs(route: ActivatedRoute, breadcrumbs: IBreadcrumb[] = []): IBreadcrumb[] {
    const ROUTE_DATA_BREADCRUMB = 'breadcrumb';

    // get the child routes
    const children: ActivatedRoute[] = route.children;

    // iterate over each children
    for (const child of children) {
      // verify primary route
      if (child.outlet !== PRIMARY_OUTLET) {
        continue;
      }

      // verify the custom data property 'breadcrumb' is specified on the route
      if (!child.snapshot.data.hasOwnProperty(ROUTE_DATA_BREADCRUMB)) {
        continue;
      }

      const label: string = child.snapshot.data[ROUTE_DATA_BREADCRUMB];

      // verify that label is not empty
      if (label && label.trim().length > 0) {

        // add breadcrumb
        const breadcrumb: IBreadcrumb = {
          label,
          params: child.snapshot.params,
          url: this.router.createUrlTree(['.'], { relativeTo: child }).toString(),
          previous: this.last,
        };
        breadcrumbs.push(breadcrumb);

        this.last = breadcrumb;
      }

      return this.getBreadcrumbs(child, breadcrumbs);
    }
    return breadcrumbs;
  }

}
